module.exports = __webpack_public_path__ + "img/gamifinnator-gamifinna.2f28c929.png";